import { observable, computed } from "mobx";

import { Common_Utils, languageSet, dateUtil, formatConstants, SetterModel } from "@qubit-utill/src";
import { DefenseDataTypeOrderModel } from "@src/pages/Filter/RegisterFilter/model/DataType";

class SystemFilterModel extends SetterModel {
  constructor(params, CodeStore) {
    super(params);
    this.CodeStore = CodeStore;
    if (params) {
      this.filterOs = params.typeos;
      this.riskLevel = params.filterRiskLevel;
      this.filterEventType = params.filterEventName
        ? `${
            params.filterEventName.length > 50
              ? Common_Utils.textOverflow(params.filterEventName.replace(/\n/gi, ""), 50)
              : params.filterEventName
          }(${params.filterEventKey})`
        : "-";
      this.detectStartTime = dateUtil.newDate(params.detectStartTime, null);
      this.detectEndTime = dateUtil.newDate(params.detectEndTime, null);
    }
  }
  @observable
  CodeStore;

  @observable
  osFamily: string = "";

  @computed
  get isUseFlag() {
    return Common_Utils.isCheckBool(this.isUse);
  }

  @computed
  get isLockFlag() {
    return Common_Utils.isCheckBool(this.isLock);
  }

  @computed
  get isDetectDisplayFlag() {
    return Common_Utils.isCheckBool(this.isDetectDisplay);
  }

  @computed
  get isUseUserDescriptionFlag() {
    return Common_Utils.isCheckBool(this.isUseUserDescription);
  }

  @computed
  get isCustomFilterName() {
    return this.isCustomFilter === "0" ? languageSet("추천") : languageSet("사용자");
  }

  @computed
  get riskName() {
    return this.CodeStore.getCodeName("filterRiskLevel", this.filterRiskLevel);
  }

  @computed
  get isUseCustomFlag() {
    return Common_Utils.isCheckBool(this.isUseCustom);
  }

  @computed
  get isDetectTimeRangeUseFlag() {
    return Common_Utils.isCheckBool(this.isDetectTimeRangeUse);
  }

  @computed
  get detectStartTimeFormat() {
    return this.detectStartTime ? dateUtil.format(this.detectStartTime, formatConstants.TIMEFORMAT) : null;
  }
  @computed
  get detectEndTimeFormat() {
    return this.detectEndTime ? dateUtil.format(this.detectEndTime, formatConstants.TIMEFORMAT) : null;
  }

  @computed
  get isPossibleAddDataType() {
    return Boolean(this.filterEventId);
  }

  @computed
  get filterDetectTypeName() {
    return Common_Utils.isDataWithDashBar(this.CodeStore.getCodeName("filterDetectType", this.filterDetectType));
  }

  @computed
  get isUseFilterElementAdditionalFlag() {
    return Boolean(this.refFilterId);
  }

  @computed
  get isDefenseTypeFlag() {
    return this.filterDetectType === "defense";
  }

  @computed
  get isEventDataFlag() {
    return this.filterElementRoot === "EventData";
  }

  @observable
  isDisplay: string = "";

  @observable
  filterNo: number = 0;

  @observable
  filterId: string = "";

  @observable
  filterType: string = ""; //20 = 보안 10 = 관리

  @observable
  isDetectDisplay: string = "";

  @observable
  isUseUserDescription: string = "";

  @observable
  isUse: string = "1";

  isGlobalFilter: string = "";

  @observable
  filterRiskLevel: string = "";

  @observable
  isCustomFilter: string = "1";

  @observable
  isLock: string = "";

  @observable
  filterName: string = "";

  @observable
  filterDescription: string = "";

  @observable
  filterUserDescription: string = "";

  @observable
  filterEventId: number = 0;

  @observable
  filterEventName: string = "";

  @observable
  filterElement: string = "";

  @observable
  filterElementJson = [];

  @observable
  filterCustomConfigId: number = 0;

  @observable
  serverGroupId = null;

  @observable
  typeos: string = "";

  @observable
  isUseCustom: string = "0";

  @observable
  filterElementRoot: string = "";

  @observable
  filterChannelId: number = 0;

  @observable
  filterChannelName: string = "";

  @observable
  isSingleEvent: string = "";

  filterChannelOrderNo: string = "";

  @observable
  filterCategoryId: number = 1; //분류

  @observable
  filterCategoryName: string = ""; //분류

  filterCategoryType: string = "";

  @observable
  filterOs: string = "";

  @observable
  serverGroup: string = "";

  @observable
  coverage: string = "";

  @observable
  riskLevel: string = "";

  @observable
  filterEventType: string = "-";

  @observable
  securityFilterType: string = "";

  @observable
  isSelected: boolean = false;

  @observable
  isDetectTimeRangeUse: string = "";

  @observable
  detectStartTime: string | Date | null = null;

  @observable
  detectEndTime: string | Date | null = null;

  @observable
  filterEventKey: string = "";

  @observable
  filterDetectType: string = "detect";

  @observable
  refFilterId: string = "";

  @observable
  isUseFilterElementAdditional: string = "0";

  @observable
  filterElementAdditionalJson = [];

  @observable
  logTag: string = "";

  @observable
  isAutoDefense: string = "0";

  @observable
  isUseRecover: string = "0";

  @observable
  edrFilterElementList?: Array<DefenseDataTypeOrderModel> = [];
}

export default SystemFilterModel;
